import { useEffect, useRef, useState } from 'react';
import { Box } from '@mui/material';
import type { Slide } from '../types/slide';
import { CANVAS } from '../lib/brand';
import { slideSurfaceStyle } from '../lib/slideStyle';
import { SlideElementView } from './elements/SlideElements';

/** Non-interactive rendering of a slide that fills its container's width at 16:9. */
export function SlideThumbnail({ slide }: { slide: Slide | null }) {
  const ref = useRef<HTMLDivElement>(null);
  const [scale, setScale] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const ro = new ResizeObserver(() => setScale(el.clientWidth / CANVAS.width));
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  return (
    <Box
      ref={ref}
      sx={{ position: 'relative', width: '100%', aspectRatio: '16 / 9', overflow: 'hidden', bgcolor: 'chrome.subtle' }}
    >
      {slide && scale > 0 && (
        <div
          inert
          aria-hidden
          style={{
            ...slideSurfaceStyle(slide),
            position: 'absolute',
            left: 0,
            top: 0,
            transformOrigin: 'top left',
            transform: `scale(${scale})`,
            pointerEvents: 'none',
          }}
        >
          {slide.elements.map((el) => (
            <SlideElementView
              key={el.id}
              el={el}
              selected={false}
              scale={1}
              onSelect={() => undefined}
              onChangeText={() => undefined}
              onDragEnd={() => undefined}
            />
          ))}
        </div>
      )}
    </Box>
  );
}
